import React from 'react';
import styled from 'styled-components';

import { Flex } from 'components';

interface CardSquareProps {
  lineHeight?: number;
  color?: 'gray' | 'white' | 'green';
}

const BoxLines = styled('div')<CardSquareProps>`
  position: relative;
  width: 1px;
  height: ${(props) => `${props.lineHeight}px`};

  border-width: 0 2px 0 0;
  border-style: solid;
  border-color: ${({ theme, color }) => {
    switch (color) {
      case 'white':
        return theme.colors.white;

      case 'green':
        return theme.colors.dark_150;

      case 'gray':
      default:
        return theme.colors.gray_500;
    }
  }};

  &::before {
    content: '';
    display: block;
    width: 14px;
    height: 14px;
    background: ${({ theme, color }) => {
      switch (color) {
        case 'white':
          return theme.colors.white;

        case 'green':
          return theme.colors.primary_400;

        case 'gray':
        default:
          return theme.colors.gray_500;
      }
    }};
    position: absolute;
    bottom: 0;
    left: 0;
  }
`;

const CardSquare = ({ lineHeight, color }: CardSquareProps) => {
  const boxLineHeight = lineHeight || 80;
  const boxColor = color || 'gray';

  return (
    <Flex>
      <BoxLines lineHeight={boxLineHeight} color={boxColor} />
    </Flex>
  );
};

export default CardSquare;
